import type { SettingsSectionId } from './SettingsSidebar';
import { GeneralSection } from './sections/GeneralSection';
import { FinancialSection } from './sections/FinancialSection';
import { ChannelsSection } from './sections/ChannelsSection';
import { AiSection } from './sections/AiSection';
import { IntegrationsSection } from './sections/IntegrationsSection';

interface SettingsContentProps {
  activeSection: SettingsSectionId;
}

export function SettingsContent({ activeSection }: SettingsContentProps) {
  switch (activeSection) {
    case 'financial':
      return <FinancialSection />;
    case 'general':
      return <GeneralSection />;
    case 'channels':
      return <ChannelsSection />;
    case 'ai':
      return <AiSection />;
    case 'integrations':
      return <IntegrationsSection />;
    default:
      return <GeneralSection />;
  }
}
